import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=a9ece13e&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=a9ece13e&prod&lang=less&scoped=true"
import style1 from "./Notification.vue?vue&type=style&index=1&id=a9ece13e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ece13e",
  null
  
)

export default component.exports